var _g, _rect, _rect2, _tspan, _tspan2, _g2, _circle, _rect3, _tspan3, _path, _circle2, _rect4, _tspan4, _path2, _circle3, _tspan5, _tspan6, _rect5, _tspan7, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScene4Mechanism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 281.25,
    viewBox: "0 0 132.29 74.414",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.7812 -27.932)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "review-form",
    transform: "matrix(.77589 0 0 .77589 5.8405 39.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.39587,
    y: 0.39587,
    width: 57.946,
    height: 60.592,
    rx: 0.51151,
    ry: 0.51151,
    fill: "none",
    stroke: "#aa9de2",
    strokeMiterlimit: 10,
    strokeWidth: 0.26258
  }))), /*#__PURE__*/React.createElement("g", {
    className: "mech",
    transform: "matrix(.7689 0 0 .7689 1.9428 31.862)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.616,
    y: 5.8395,
    width: 93.398,
    height: 66.675,
    rx: 0.68821,
    ry: 0.68821,
    fill: "none",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.26492
  })), /*#__PURE__*/React.createElement("g", {
    className: "browser-act",
    transform: "translate(0 -1.0583)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 0.265
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.048,
    y: 55.786,
    width: 86.916,
    height: 13.824,
    rx: 1.3764,
    ry: 1.3764,
    fill: "none",
    stroke: "#808080"
  })), /*#__PURE__*/React.createElement("text", {
    x: 96.659721,
    y: 67.197823,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.8175px",
    fontWeight: "bold",
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 96.659721,
    y: 67.197823,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8175px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "\"Applicant Approved!\""))), /*#__PURE__*/React.createElement("text", {
    x: 96.5709,
    y: 61.252663,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.8175px",
    fontWeight: "bold",
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 96.5709,
    y: 61.252663,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8175px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "Show a Pop-up Message saying")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0048027 0 0 .0048027 88.908 57.554)",
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(3.6036)",
    d: "m41 25h252c17.12 0 31 17.12 31 31v175.13c0 17.12-13.879 31.003-31 31.003h-252c-17.12 0-31-17.123-31-31.003v-175.13c0-17.12 13.879-31 31-31z",
    fill: "none",
    strokeWidth: 13.331
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(3.6036)",
    d: "m9.9998 86h314",
    fill: "none",
    strokeWidth: 13.331
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.3 205.41c0 17.91-14.52 32.43-32.43 32.43-17.914 0-32.434-14.52-32.434-32.43 0-17.914 14.52-32.434 32.434-32.434 17.91 0 32.43 14.52 32.43 32.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.2 205.41c0 17.91-14.523 32.43-32.434 32.43s-32.434-14.52-32.434-32.43c0-17.914 14.523-32.434 32.434-32.434s32.434 14.52 32.434 32.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.02 205.41c0 17.91-14.523 32.43-32.434 32.43-17.914 0-32.434-14.52-32.434-32.43 0-17.914 14.52-32.434 32.434-32.434 17.91 0 32.434 14.52 32.434 32.434"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "browser-plus",
    transform: "translate(-33.744 23.059)",
    fill: "none",
    opacity: 0,
    stroke: "#babfc3",
    strokeMiterlimit: 10
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 -22.225)",
    cx: 164.32,
    cy: 58.036,
    r: 2.6458,
    strokeWidth: 0.26511
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.15919 0 0 .15918 75.425 6.5202)",
    d: "m566.69 184.02-8.2406 0.0654-0.0654 8.2406-0.0654-8.2406-8.2406-0.0654 8.2406-0.0654 0.0654-8.2406 0.0654 8.2406z",
    strokeLinecap: "round",
    strokeWidth: 1.6621,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "sms-act"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.18,
    y: 43.524,
    width: 86.783,
    height: 7.3285,
    rx: 1.3764,
    ry: 1.3764,
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeWidth: 0.265
  })), /*#__PURE__*/React.createElement("text", {
    x: 95.930611,
    y: 48.628708,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.8175px",
    fontWeight: "bold",
    strokeMiterlimit: 10,
    strokeWidth: 0.265,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 95.930611,
    y: 48.628708,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8175px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "Send a Text  Message"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m91.795 46.372c0.26896 0 0.48132 0.21942 0.48132 0.48132 0 0.26896-0.21235 0.48131-0.48132 0.48131-0.2619 0-0.48132-0.21235-0.48132-0.48131 0-0.2619 0.21942-0.48132 0.48132-0.48132zm-1.5209 2.9164 0.49069-0.60004 2.9271-0.0018c0.43885-2.67e-4 0.79277-0.36098 0.79277-0.79277v-2.0739c0-0.43885-0.35392-0.79277-0.79277-0.79277h-3.7868c-0.43885 0-0.79277 0.35392-0.79277 0.79277v2.0739c0 0.43177 0.35392 0.79277 0.79277 0.79277h0.40345zm0.53001-0.44643-0.65131 0.87802v-0.8777h-0.24773c-0.52378 0-0.94849-0.43177-0.94849-0.9485v-2.0739c0-0.52378 0.4247-0.94849 0.94849-0.94849h3.7868c0.51674 0 0.94849 0.4247 0.94849 0.94849v2.0739c0 0.51674-0.43177 0.9485-0.94849 0.9485zm-0.27614-2.47c0.2619 0 0.48132 0.21941 0.48132 0.48132 0 0.26897-0.21941 0.48132-0.48132 0.48132-0.26896 0-0.48132-0.21235-0.48132-0.48132 0-0.2619 0.21235-0.48132 0.48132-0.48132zm0 0.15571c-0.17695 0-0.3256 0.14865-0.3256 0.3256 0 0.18404 0.14865 0.3256 0.3256 0.3256s0.3256-0.14156 0.3256-0.3256c0-0.17695-0.14865-0.3256-0.3256-0.3256zm2.5411-0.15571c0.2619 0 0.48132 0.21941 0.48132 0.48132 0 0.26897-0.21942 0.48132-0.48132 0.48132-0.26897 0-0.48132-0.21235-0.48132-0.48132 0-0.2619 0.21235-0.48132 0.48132-0.48132zm0 0.15571c-0.18403 0-0.3256 0.14865-0.3256 0.3256 0 0.18404 0.14157 0.3256 0.3256 0.3256 0.17695 0 0.3256-0.14156 0.3256-0.3256 0-0.17695-0.14865-0.3256-0.3256-0.3256zm-1.2741 0c-0.17695 0-0.3256 0.14865-0.3256 0.3256 0 0.18404 0.14865 0.3256 0.3256 0.3256 0.18403 0 0.3256-0.14156 0.3256-0.3256 0-0.17695-0.14157-0.3256-0.3256-0.3256z",
    fill: "#333",
    stroke: "#333",
    strokeWidth: 0.13229
  }))), /*#__PURE__*/React.createElement("g", {
    className: "sms-plus",
    transform: "translate(-33.744 11.417)",
    fill: "none",
    opacity: 0,
    stroke: "#babfc3",
    strokeMiterlimit: 10
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(0 -22.225)",
    cx: 164.32,
    cy: 58.036,
    r: 2.6458,
    strokeWidth: 0.26511
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.15919 0 0 .15918 75.425 6.5202)",
    d: "m566.69 184.02-8.2406 0.0654-0.0654 8.2406-0.0654-8.2406-8.2406-0.0654 8.2406-0.0654 0.0654-8.2406 0.0654 8.2406z",
    strokeLinecap: "round",
    strokeWidth: 1.6621,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "email-act"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.18,
    y: 32.147,
    width: 86.783,
    height: 7.3285,
    rx: 1.3764,
    ry: 1.3764,
    fill: "none",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeWidth: 0.26511
  })), /*#__PURE__*/React.createElement("text", {
    x: 95.930611,
    y: 37.546204,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.8175px",
    fontWeight: "bold",
    strokeMiterlimit: 10,
    strokeWidth: 0.265,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 95.930611,
    y: 37.546204,
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8175px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "Send an Email"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m89.836 38.232h3.9419c0.53835 0 0.97549-0.43716 0.97549-0.97549v-2.636c0-0.53835-0.43716-0.97549-0.97549-0.97549h-3.9419c-0.53835 0-0.97549 0.43716-0.97549 0.97549l3.1e-5 2.636c0 0.53835 0.43716 0.97549 0.97549 0.97549zm4.5461-0.97549c0 0.33319-0.27102 0.60424-0.60424 0.60424h-3.9419c-0.33319 0-0.60424-0.27101-0.60424-0.60424l3.1e-5 -2.636c0-0.08448 0.01764-0.1652 0.04919-0.23854l2.067 1.7505c0.13829 0.11696 0.30721 0.17542 0.47614 0.17542 0.16893 0 0.33785-0.05846 0.47522-0.17449l2.0419-1.7273c0.026 0.06683 0.03991 0.13922 0.03991 0.21533v2.635zm-0.60514-3.2402c0.12252 0 0.23575 0.03713 0.33135 0.09931l-2.0494 1.7338c-0.13645 0.11602-0.33506 0.11602-0.47151 0l-2.0624-1.7468c0.09098-0.05475 0.19678-0.08632 0.30999-0.08632z",
    fill: "#333",
    strokeWidth: 0.0077346
  }))), /*#__PURE__*/React.createElement("g", {
    className: "email-plus",
    transform: "translate(-33.744 .039944)",
    fill: "none",
    opacity: 0,
    stroke: "#babfc3",
    strokeMiterlimit: 10
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.32,
    cy: 35.771,
    r: 2.0344,
    opacity: 1,
    strokeWidth: 0.20384
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.15919 0 0 .15918 75.425 6.5202)",
    d: "m566.69 184.02-8.2406 0.0654-0.0654 8.2406-0.0654-8.2406-8.2406-0.0654 8.2406-0.0654 0.0654-8.2406 0.0654 8.2406z",
    strokeLinecap: "round",
    strokeWidth: 1.6621,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 86.995621,
    y: 29.038029,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.1293px",
    fontWeight: "bold",
    strokeMiterlimit: 10,
    strokeWidth: 0.265,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 86.995621,
    y: 29.038029,
    fill: "#808080",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.1293px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "Actions"))), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("text", {
    x: 89.112289,
    y: 20.812956,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.8175px",
    fontWeight: "bold",
    strokeWidth: 0.265,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.112289,
    y: 20.812956,
    fill: "#333333",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.8175px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "When this button is clicked"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.099,
    y: 15.286,
    width: 86.738,
    height: 7.2829,
    rx: 1.3764,
    ry: 1.3764,
    fill: "none",
    stroke: "#808080",
    strokeWidth: 0.31064
  }))), /*#__PURE__*/React.createElement("text", {
    x: 86.995621,
    y: 12.527234,
    fill: "#333333",
    fontFamily: "'Noto Sans CJK HK'",
    fontSize: "4.1293px",
    fontWeight: "bold",
    strokeMiterlimit: 10,
    strokeWidth: 0.265,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 86.995621,
    y: 12.527234,
    fill: "#808080",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "4.1293px",
    fontWeight: "normal",
    strokeWidth: 0.265
  }, "Trigger")))), /*#__PURE__*/React.createElement("g", {
    className: "arrow"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "path-line",
    d: "m45.222 83.054c16.429 0 3.489-35.248 19.905-35.248",
    fill: "none",
    markerEnd: "",
    stroke: "#392781",
    strokeMiterlimit: 10,
    strokeWidth: 0.20376
  })), /*#__PURE__*/React.createElement("path", {
    className: "path-head",
    d: "m64.639 47.123-0.14453 0.14453 0.53906 0.53906-0.53906 0.53906 0.14453 0.14453 0.68359-0.68359z",
    color: "#000000",
    fill: "#392781",
    style: {
      InkscapeStroke: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene4Mechanism);
export default __webpack_public_path__ + "static/media/scene4-mechanism.387356aa2dabe0b368c1a893eca4c74e.svg";
export { ForwardRef as ReactComponent };